import React, { useState, useEffect } from 'react';

export interface SearchBarProps {
  /** Valor controlado externamente (ex.: limpar filtros) */
  value: string;
  /** Callback debounced pelo pai */
  onChange: (value: string) => void;
}

/**
 * Campo de busca do header com estado local para digitação fluida.
 * @param props - Valor externo e callback de mudança
 */
export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(newValue);
  };

  return (
    <label className="flex flex-col relative group">
      <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
        <span className="material-symbols-outlined text-slate-400 !text-[14px]">search</span>
      </div>
      <input
        value={localValue}
        onChange={handleChange}
        className="form-input flex w-48 lg:w-64 h-7 rounded-full border-none bg-slate-100/80 px-8 text-[11px] focus:ring-2 focus:ring-secondary-accent/20 focus:bg-white placeholder:text-slate-400 text-slate-700 transition-all font-medium"
        placeholder="Pesquisar..."
        aria-label="Pesquisar colaboradores"
      />
    </label>
  );
};
